import PropTypes from 'prop-types';

import { PartnerPhotoPlaceholder } from './partner-photo-placeholder';

import styles from './PartnerPhoto.scss';
import { useState } from 'react';

export const PartnerPhoto = ({ partner: { photoUrl, name } = { photoUrl: '', name: '' } }) => {
  const [imageUrl, setImageUrl] = useState(photoUrl);
  return (
    <figure className={styles.PartnerPhoto}>
      {imageUrl ? (
        <img
          src={imageUrl}
          alt="Partner"
          className={styles.Image}
          onError={() => setImageUrl('')}
        />
      ) : (
        <PartnerPhotoPlaceholder>{name.charAt(0).toUpperCase()}</PartnerPhotoPlaceholder>
      )}
    </figure>
  );
};

PartnerPhoto.propTypes = {
  partner: PropTypes.shape({
    photoUrl: PropTypes.string,
    name: PropTypes.string,
  }),
};
